import { DropdownIcon } from '@libs/components';
import { NavLink } from 'react-router-dom';
import styled, { css, keyframes } from 'styled-components';

type NavItemProps = {
  $isNew?: boolean;
  backgroundColor?: string;
  isComingSoon?: boolean;
};

const circularAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;

  margin-right: 0.8rem;
`;

export const LottieWrapper = styled.div`
  width: 5.4rem;
  margin-left: 1rem;
`;

export const NavItem = styled(NavLink)<NavItemProps>`
  display: flex;
  align-items: center;

  width: 100%;

  border-radius: ${({ theme }) => theme.borderRadius.x3};

  text-decoration: none;

  margin-bottom: 0.4rem;
  pointer-events: ${({ isComingSoon }) => (isComingSoon ? 'none' : 'unset')};
  ${({ $isNew }) =>
    css`
      padding: 1.2rem 1.2rem;

      border: 1px solid transparent;

      overflow: hidden;

      &.active {
        /* border: 1px solid
              ${({ theme }) => theme.colors.interactive.brandColor}; */

        background-color: ${({ theme }) => theme.colors.interactive.secondary};
      }

      ${({ theme }) => {
        const backgroundColor = theme.colors.surface.interactiveDefault;
        return theme.media.laptop`
              &:hover {
                background-color: ${
                  backgroundColor as unknown as TemplateStringsArray
                }
              }
            `;
      }}
    `};
`;

export const CustomDropDownIcon = styled(DropdownIcon)`
  transform: rotate(-90deg);
  margin-left: 3.2rem;
`;
export const NewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.8rem;
  height: 2rem;
  border-radius: ${({ theme }) => theme.borderRadius.x32};
  background-color: ${({ theme }) => theme.colors.text.success};
  margin-left: 0.8rem;
`;
export const ComingSoonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.8rem;
  height: 2rem;
  border-radius: ${({ theme }) => theme.borderRadius.x32};
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
  margin-left: 0.8rem;
`;
export const Disabled = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.5;
  pointer-events: none;
`;
